import './charts'
import './inputLargeTextarea'
import './ZohoChat'
import './unlayer'
import './camera'
import './versionChecker'
import './signature'
import './MetaEmbeddedSignUp'

declare var QRCode: any;

(<any>window).setTitle = (title: string) => {
    // console.log('setting title to: ', title);
    document.title = title;
}

(<any>window).getIpAddress = () => {
    return fetch('https://jsonip.com/')
        .then((response) => response.json())
        .then((data) => {
            return data.ip
        })
}

(<any>window).getUserAgent = () => {
    return navigator.userAgent;
}

(<any>window).createQRCode = (element: string, url: string) => {
    // https://davidshimjs.github.io/qrcodejs/
    const qrcode = new QRCode(element, {
        text: url,
        width: 128 * 2,
        height: 128 * 2,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
    });
    return "";
}

(<any>window).downloadFromUrl = (options: { url: string, fileName?: string }) => {
    const anchorElement = document.createElement("a");
    anchorElement.href = options.url;
    anchorElement.download = options.fileName ?? '';
    anchorElement.style.display = "none";
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
}

let tooltips: any[];
(<any>window).addTooltips = () => {
    if (tooltips == null) {
        tooltips = [];
    }

    const element = document.querySelector('[data-toggle="tooltip"]');
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        // @ts-ignore
        const tooltip = new bootstrap.Tooltip(tooltipTriggerEl);
        tooltips.push(tooltip)
        return tooltip;
    });
}

(<any>window).removeTooltips = () => {
    if (tooltips != null) {
        for (let i = 0; i < tooltips.length; i++) {
            //console.log(tooltips[i]);
            tooltips[i].hide();
        }
    }
}

// disabled for waf: MMPPS-4102
(<any>window).getCookie = (name: string) => {
    return getCookie(name);
};
(<any>window).getBrowserId = () => {
    return getCookie('ocep-c-id');
};

// (<any>window).createBrowserId = () => {
//     const name = "ocep-c-id";
//     let myCookie = getCookie(name);
//     if (myCookie == null) {
//         let uid = uuidv4();
//         document.cookie = name + "=" + uid;
//         console.log("GUID: " + uid)
//     } else {
//         console.log("Cookie: " + myCookie);
//     }
// }

function getRootDomain() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    // Handle known multi-level TLDs
    // need to update this in future as more TLDs are added
    const multiLevelTlds = ['co.za', 'co.uk', 'com.au', 'co.nz'];
    for (let tld of multiLevelTlds) {
        if (hostname.endsWith(tld)) {
            // Take 3 parts for multi-level TLDs: subdomain.domain.co.za -> .domain.co.za
            if (parts.length >= 3) {
                return '.' + parts.slice(-3).join('.');
            }
        }
    }
    // Default behavior for regular TLDs (.com, .org, etc.)
    if (parts.length >= 2) {
        return '.' + parts.slice(-2).join('.');
    }
    return hostname;
}

(<any>window).createBrowserId = () => {
    const name = "ocep-c-id";
    let myCookie = getCookie(name);
    if (myCookie == null) {
        let uid = uuidv4();
        const rootDomain = getRootDomain();
        document.cookie = [
            `${name}=${uid}`,
            `domain=${rootDomain}`,
            'path=/',
            'SameSite=Lax',
            location.protocol === 'https:' ? 'Secure' : ''
        ].filter(Boolean).join('; ');
        console.log("GUID: " + uid + " for domain: " + rootDomain);
    } else {
        console.log("Cookie: " + myCookie);
    }
}

function getCookie(name: string) {
    let dc = document.cookie;
    let prefix = name + "=";
    let begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin == -1) return null;
    } else {
        begin += 2;
    }
    let end = dc.indexOf(";", begin);
    if (end == -1) {
        end = dc.length;
    }
    return decodeURIComponent(dc.substring(begin + prefix.length, end));
}


function uuidv4() {
    return window.URL.createObjectURL(new Blob([])).split('/').pop();
}

(<any>window).getSelectedText = (elementId: string) => {
    const textarea = document.getElementById(elementId) as HTMLTextAreaElement;
    return textarea.value.substring(textarea.selectionStart, textarea.selectionEnd);
};

(<any>window).clickElementById = (elementId: string) => {
    const element = document.getElementById(elementId);
    if (element) {
        element.click();
    }
};

(<any>window).openInTab = (url: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

(<any>window).copyJsonToClipboard = async function (json: string) {
    try {
        await navigator.clipboard.write([
            new ClipboardItem({
                "text/plain": new Blob([json], {type: "text/plain"})
            })
        ]);
        //alert("Copied to clipboard!");
    } catch (err) {
        console.error("Clipboard copy failed", err);
        //alert("Copy failed: " + err);
    }
}
